import { render } from "./downloadapp.vue?vue&type=template&id=6dd0b358&scoped=true"
const script = {}

import "./downloadapp.vue?vue&type=style&index=0&id=6dd0b358&lang=css&scoped=true"

import exportComponent from "C:\\Users\\Acer\\Desktop\\mav\\surkhet\\patient-portal-v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd0b358"]])

export default __exports__